<script setup lang="ts">
import type { OptionProps } from '@formwerk/core'
import { useOption } from '@formwerk/core'

const props = defineProps<OptionProps<string>>()

const { optionProps, isSelected } = useOption(props)
</script>

<template>
  <div
    v-bind="optionProps"
    class="typo-sans-1 px-2 py-0.5 motion-snug border border-transparent cursor-pointer select-none uppercase @hover:bg-current/8 aria-selected:bg-current/8 aria-disabled:opacity-50 aria-disabled:cursor-not-allowed"
    :class="{
      'bg-current/10 border-transparent': isSelected,
    }"
  >
    {{ label }}
  </div>
</template>
